import tableQuery from 'assets/js/editor/table/table-query';

export function loadTableEvents (popup, popupMenuCommonFunctions, canvas) {
  // Event listeners
  let textAreas = [];
  let paddings = [];
  const shortTimeOut = 60;
  const listeners = {
    'on_open-table-editor': () => INKIVE.Table.beginTableEditingMode(popup.element()),
    'on_close-table-editor': () => INKIVE.Table.endTableEditingMode(),
    'on_select-all-cells': () => INKIVE.Table.tableSelectionInstance && INKIVE.Table.tableSelectionInstance.selectAll(),
    'on_invert-cell-selection': () => INKIVE.Table.tableSelectionInstance && INKIVE.Table.tableSelectionInstance.invertSelection(),
    'on_insert-row-before': () => INKIVE.Table.insertRow(true),
    'on_insert-row-after': () => INKIVE.Table.insertRow(false),
    'on_delete-row': () => INKIVE.Table.deleteRow(),
    'on_insert-column-before': () => INKIVE.Table.insertColumn(true),
    'on_insert-column-after': () => INKIVE.Table.insertColumn(false),
    'on_delete-column': () => INKIVE.Table.deleteColumn(),
    'on_merge-cells': () => INKIVE.Table.merge(),
    'on_split-cell': () => INKIVE.Table.split(),
    'on_cell-bold': () => {
      const isApplied = popup.button('on_cell-bold')[0].classList.contains('applied');
      const fontWeight = isApplied ? '400' : '700';

      INKIVE.DesignFacade.set({ cell_font_weight: fontWeight });
      INKIVE.Table.updateTableToolBar(popup.element());
    },
    'on_cell-italic': () => {
      const isApplied = popup.button('on_cell-italic')[0].classList.contains('applied');
      const fontStyle = isApplied ? 'normal' : 'italic';

      INKIVE.DesignFacade.set({ cell_font_style: fontStyle });
      INKIVE.Table.updateTableToolBar(popup.element());
    },
    'on_cell-underline': () => {
      const isApplied = popup.button('on_cell-underline')[0].classList.contains('applied');
      const textDecoration = isApplied ? 'normal' : 'underline';

      INKIVE.DesignFacade.set({ cell_text_decoration: textDecoration });
      INKIVE.Table.updateTableToolBar(popup.element());
    },
    'on_cell-list': () => {
      const isApplied = popup.button('on_cell-list')[0].classList.contains('applied');
      const isList = !isApplied;

      INKIVE.DesignFacade.set({ cell_list: isList });
      INKIVE.Table.updateTableToolBar(popup.element());
    },
    'on_cell-bullets': () => {
      const isApplied = popup.button('on_cell-bullets')[0].classList.contains('applied');
      const isBullets = !isApplied;

      INKIVE.DesignFacade.set({ cell_bullets: isBullets });
      INKIVE.Table.updateTableToolBar(popup.element());
    },
    'on_cell-text-typing': () => {
      textAreas = calculateTextAreasElement(popup.element());
      canvas.runExtensions('beginTextTyping', {
        elem: textAreas[0]
      });
    },
    'on_cell-case': () => {
      const isApplied = popup.button('on_cell-case')[0].classList.contains('applied');
      const isUpperCase = !isApplied;

      INKIVE.DesignFacade.set({ cell_case: isUpperCase });
      INKIVE.Table.updateTableToolBar(popup.element());
    }
  };

  // Attach listeners to UI elements
  Object.keys(listeners).forEach(toolbarButtonName => {
    popup.button(toolbarButtonName).on('click', listeners[toolbarButtonName]);
  });

  const sliderListeners = ['paragraph-spacing', 'line-spacing', 'word-spacing', 'letter-spacing', 'first-line-margin', 'line-margin', 'right-margin'];

  for (const sliderListener of sliderListeners) {
    popup.button(`on_set-cell-${sliderListener}`)
      .on('start', function () {
        textAreas = calculateTextAreas(popup.element());
        paddings = calculatePaddings(textAreas, sliderListener);
      })
      .on('change', _.throttle(function (e, value) {
        if (typeof value === 'undefined') return;
        for (let i = 0; i < textAreas.length; i++) {
          const textArea = textAreas[i];
          if (!textArea) continue;

          const spacing = paddings[i] + parseFloat(value);
          textArea.text.setValues({ [sliderListener.replaceAll('-', '_')]: spacing });
          canvas.runExtensions('renderTextArea', { textArea });
        }
      }, shortTimeOut))
      .on('stop', function (e, value) {
        INKIVE.DesignFacade.set({
          cell_spacing: { value, action: 'stop', type: sliderListener.replaceAll('-', '_'), textAreas, paddings }
        });
      });
  }
}

function calculatePaddings (textareas, sliderListener) {
  const paddings = [];
  const leftPadding = ['line-margin', 'first-line-margin'];
  const rightPadding = ['right-margin'];

  for (const textarea of textareas) {
    const cellElement = textarea.dom.parentElement;
    const padding = tableQuery.getCellPadding(cellElement);

    if (leftPadding.includes(sliderListener)) {
      paddings.push(padding.left);
    } else if (rightPadding.includes(sliderListener)) {
      paddings.push(padding.right);
    } else {
      paddings.push(0);
    }
  }
  return paddings;
}

export function calculateTextAreas (tableElement) {
  const textAreas = [];

  let cellRectElements = tableElement.querySelectorAll('rect.table-cell-selected');

  if (!cellRectElements.length) {
    cellRectElements = tableElement.querySelectorAll('rect:not(.highlight-rect)');
  }

  for (const cellRectElement of cellRectElements) {
    const textAreaElement = cellRectElement.parentElement;
    const textArea = new INKIVE.Text.Textarea().setDOM(textAreaElement);

    if (!textArea) continue;

    textAreas.push(textArea);
  }

  return textAreas;
}

export function calculateTextAreasElement (tableElement) {
  const textAreas = [];

  let cellRectElements = tableElement.querySelectorAll('rect.table-cell-selected');

  if (!cellRectElements.length) {
    cellRectElements = tableElement.querySelectorAll('rect:not(.highlight-rect)');
  }

  for (const cellRectElement of cellRectElements) {
    const textAreaElement = cellRectElement.parentElement;
    if (!textAreaElement) continue;

    textAreas.push(textAreaElement);
  }

  return textAreas;
}
